import { useState } from "react";
import { toast } from "sonner";
import { LogOut, Pause, Play } from "lucide-react";
import { api } from "@/lib/api";

// Owner controls: end every sign-in an assistant has, or pause them until you turn them back on.
export default function MemberAccess({ m, onChanged }) {
  const [busy, setBusy] = useState("");
  const run = async (kind, fn) => {
    setBusy(kind);
    try { await fn(); } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't do that. Try again."); } finally { setBusy(""); }
  };
  const signOut = () => run("out", async () => {
    await api.post(`/team/${m.id}/sign-out`);
    toast.success(`${m.email} is signed out on every device. They can sign back in.`);
  });
  const pause = () => {
    if (!m.paused && !window.confirm(`Pause ${m.email}? They'll be signed out and can't sign back in until you resume them.`)) return;
    run("pause", async () => {
      await api.put(`/team/${m.id}/pause`, { paused: !m.paused });
      toast.success(m.paused ? `${m.email} can sign in again` : `${m.email} is paused and signed out`);
      onChanged();
    });
  };
  const btn = "inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-xs font-semibold transition-colors disabled:opacity-50";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`team-member-access-${m.id}`}>
      {m.paused && <span className="rounded-full bg-amber-100 px-2 py-0.5 font-mono text-[10px] font-semibold text-amber-800" data-testid={`team-member-paused-${m.id}`}>Paused</span>}
      <button type="button" onClick={signOut} disabled={!!busy || m.paused} className={`${btn} border-slate-300 text-slate-700 hover:border-slate-500`} data-testid={`team-member-signout-${m.id}`}>
        <LogOut className="h-3.5 w-3.5" /> {busy === "out" ? "Signing out…" : "Sign out everywhere"}
      </button>
      <button type="button" onClick={pause} disabled={!!busy}
        className={`${btn} ${m.paused ? "border-emerald-300 text-emerald-700 hover:border-emerald-500" : "border-amber-300 text-amber-800 hover:border-amber-500"}`} data-testid={`team-member-pause-${m.id}`}>
        {m.paused ? <Play className="h-3.5 w-3.5" /> : <Pause className="h-3.5 w-3.5" />} {busy === "pause" ? "Saving…" : m.paused ? "Resume access" : "Pause access"}
      </button>
    </div>
  );
}
